import React, { useState, useEffect } from 'react';
import PublicNavbar           from '../PublicNavbar/PublicNavbar';
import HeroSection            from './sections/HeroSection';
import AboutSection           from './sections/AboutSection';
import NoticesSection         from './sections/NoticesSection';
import QuestionPapersSection  from './sections/QuestionPapersSection';
import BlogsSection           from './sections/BlogsSection';
import Footer                 from './sections/Footer';
import QuestionPapersPage     from '../QuestionPapersPage/QuestionPapersPage';
import NoticesPage            from '../NoticesPage/NoticesPage';
import BlogsPage              from '../BlogsPage/BlogsPage';
import './PublicHome.css';

export default function PublicHome({ onLoginClick }) {
  const [view, setView] = useState('home'); // 'home' | 'question-papers' | 'notices' | 'blogs'
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [view]);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <div className="pub-home">

      {/* 1. NAVBAR */}
      <PublicNavbar onLoginClick={onLoginClick} onNavigate={setView} currentView={view} />

      {view === 'home' && (
        <>
          {/* 2. HERO */}
          <HeroSection onLoginClick={onLoginClick} />

          {/* 3. ABOUT */}
          <AboutSection />

          {/* 4. NOTICES */}
          <NoticesSection onSeeAllClick={() => setView('notices')} />

          {/* 5. QUESTION PAPERS SECTION */}
          <QuestionPapersSection onSeeAllClick={() => setView('question-papers')} />

          {/* 6. BLOGS */}
          <BlogsSection onSeeAllClick={() => setView('blogs')} />
        </>
      )}

      {view === 'question-papers' && (
        <QuestionPapersPage onNavigate={setView} />
      )}

      {view === 'notices' && (
        <NoticesPage onNavigate={setView} />
      )}

      {view === 'blogs' && (
        <BlogsPage onNavigate={setView} />
      )}

      {/* 7. FOOTER */}
      <Footer onNavigate={setView} />

      {/* Sticky Back-to-Top */}
      <button
        className={`pub-back-top ${showTop ? 'pub-back-top--visible' : ''}`}
        onClick={scrollToTop}
        aria-label="Back to top"
        id="back-to-top-btn"
      >
        <i className="fa-solid fa-arrow-up"></i>
      </button>

    </div>
  );
}
